import ContactSelect from './ContactSelect';
import HeroSelect from './HeroSelect';
import Main from './Main';

export default Main;

export {
  ContactSelect,
  HeroSelect,
}



// WEBPACK FOOTER //
// ./src/components/admin/Website/Main/index.js